import MessageTemplate from "@src/presentation/components/shared/message-template";
import { FaRegCopy } from "react-icons/fa";
import * as Styles from "./styles";

interface Props {
  transactionHash: string;
}
const CheckoutSuccess = ({ transactionHash }: Props): JSX.Element => {
  const copyEtherscanAddress = (event: any): void => {
    event.stopPropagation();

    navigator.clipboard.writeText(formatEtherscanAddress());
  };

  const formatEtherscanAddress = (): string => {
    return `${process.env.REACT_APP_ETHERSCAN_URL}/tx/${transactionHash}`;
  };

  return (
    <Styles.Wrapper>
      <MessageTemplate
        image=""
        primaryActionText="Keep Exploring"
        primaryActionUrl="/"
        text="Once the transaction is complete, your NFT will be available in your wallet. This operation may take several minutes. We appreciate your visit and hope to see you again in the future!"
        title="Your purchase is being processed"
      >
        <Styles.EtherscanLink>
          <p>View your transaction on Etherscan:</p>
          <Styles.CopyButton
            onClick={(event: any) => copyEtherscanAddress(event)}
          >
            <FaRegCopy />
          </Styles.CopyButton>
          <a target="_blank" href={formatEtherscanAddress()} rel="noreferrer">
            {formatEtherscanAddress()}
          </a>
        </Styles.EtherscanLink>
      </MessageTemplate>
    </Styles.Wrapper>
  );
};

export default CheckoutSuccess;
